import { useCallback, useRef } from "react";

const styles = {
  searchContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  searchTitle: {
    marginRight: "10px",
    color: "#A0A0A0",
  },
  searchInput: {
    backgroundColor: "#2C2C2C",
    border: "1px solid #3D3D3D",
    borderRadius: "10px",
    padding: "6px 12px",
    color: "#FFFFFF",
    outline: "none",
    fontFamily: "'Inter', sans-serif",
  },
};

const DEBOUNCE_TIMEOUT = 500;

const Search = ({ searchQuery }) => {
  const queryTask = useRef(null);

  const handleInput = useCallback((e) => {
    const { value } = e.target;
    queryTask.current !== null && clearTimeout(queryTask.current);
    queryTask.current = setTimeout(() => {
      searchQuery(value);
      queryTask.current = null;
    }, DEBOUNCE_TIMEOUT);
  }, []);

  return (
    <div style={styles.searchContainer}>
      <span style={styles.searchTitle}>Search:</span>
      <input
        type="text"
        name="search"
        style={styles.searchInput}
        onChange={handleInput}
      />
    </div>
  );
};

export default Search;
